import { Box, Typography } from '@mui/material';

interface AvailableSlotProps {
  style?: React.CSSProperties;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
}

export default function AvailableSlot({ style, onClick }: AvailableSlotProps) {
  return (
    <Box
      onClick={onClick}
      sx={{
        backgroundColor: '#15B79F1A',
        borderRadius: '8px',
        position: 'absolute',
        left: '10px',
        right: '10px',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        pt: '4px',
        pl: '8px',
        zIndex: 1,
        cursor: 'pointer',
        '&:hover': { backgroundColor: '#15B79F2A' },
        ...style,
      }}
    >
      <Typography
        variant="body2"
        sx={{ color: 'primary.main', fontWeight: 500 }}
      >
        Available
      </Typography>
    </Box>
  );
}
